import { Button, Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  Checkmark,
  DateInput,
  FormButton,
  FormField,
  LoadingSpinner,
  SearchTable,
  Table,
  TableItem,
  TextHeader,
  Typography,
} from '@components';
import { useCompany } from '@hooks';
import { NinjaDevice, UserNamesInterface } from '@interfaces';
import { AssetsService, UsersService } from '@services';
import { AsideInterface, addToast, clearAsides, createHardware } from '@stores';
import SelectUser from '../../organisms/users/SelectUser';

type Props = {
  hardware: AsideInterface;
};

export const AddHardware = ({ hardware }: Props) => {
  const [form] = Form.useForm();
  const [search, setSearch] = useState('');
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [remoteManaged, setRemoteManaged] = useState([]);
  const [filteredRemoteManaged, setFilteredRemoteManaged] = useState([]);
  const { companyId } = useCompany();
  const service = new AssetsService();
  const dispatch = useDispatch();
  const userService = new UsersService();
  const [users, setUsers] = useState<UserNamesInterface[]>();
  console.log(hardware);
  const fetchUsers = async () => {
    try {
      const data = await userService.getUserNames(companyId);
      console.log(data);
      setUsers(data);
    } catch (error) {
      console.error('Error fetching usernames:', error);
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const deviceIds = Object.values(hardware.data.hardware).map(
          (item: any) => item.device_id
        );

        const remoteManagedData =
          await service.fetchNinjaCompanyDevices(companyId);

        const filteredRemoteManaged = remoteManagedData.filter(
          (device: NinjaDevice) => !deviceIds.includes(String(device.id))
        );

        filteredRemoteManaged.sort((a: NinjaDevice, b: NinjaDevice) => {
          if (!a.displayName && b.displayName) return -1;
          if (a.displayName && !b.displayName) return 1;
          return 0;
        });

        setRemoteManaged(filteredRemoteManaged);
        setFilteredRemoteManaged(filteredRemoteManaged);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    fetchUsers();
  }, []);

  const onCreate = async (values: any) => {
    try {
      const hardware = {
        serialNumber: values.serial,
        name: values.name,
        category: values.category,
      };
      const newHardware = await service.addHardware(companyId, hardware);
      const newHardwareData = await service.assetDetail(
        companyId,
        newHardware.assetId
      );

      // need to return necessary from backend

      dispatch(createHardware(newHardwareData));
      dispatch(
        addToast({
          description: 'Het apparaat is aangemaakt.',
          position: 'bottomRight',
          style: 'success',
        })
      );
      closeAside();
    } catch (error) {
      console.error('Error creating hardware:', error);
    }
  };

  const closeAside = () => {
    dispatch(clearAsides());
  };

  const onNinjaAdd = async (device_id: number) => {
    setConfirmLoading(true);
    const newHardware = await service.addHardware(companyId, {
      deviceId: device_id,
    });

    const newHardwareData = await service.assetDetail(
      companyId,
      newHardware.assetId
    );
    dispatch(createHardware(newHardwareData));

    const updatedRemoteManaged = remoteManaged.filter(
      (device: NinjaDevice) => device.id !== device_id
    );
    setRemoteManaged(updatedRemoteManaged);

    const updatedFilteredRemoteManaged = filteredRemoteManaged.filter(
      (device: NinjaDevice) => device.id !== device_id
    );
    setFilteredRemoteManaged(updatedFilteredRemoteManaged);

    setConfirmLoading(false);

    dispatch(
      addToast({
        description: 'Het apparaat is toegevoegd.',
        position: 'bottomRight',
        style: 'success',
      })
    );
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearch(value);
    filterRemoteManaged(value);
  };

  const filterRemoteManaged = (value: string) => {
    const filteredServices = remoteManaged.filter((hardware: NinjaDevice) =>
      hardware.systemName.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredRemoteManaged(filteredServices);
  };

  const tableHeaders: object = ['Hardware', 'Naam', 'Online', 'Acties'];

  return (
    <div>
      <TextHeader title={'Hardware toevoegen'} />
      <Form labelAlign="left" layout="vertical" form={form} onFinish={onCreate}>
        <div className="mt-5 grid grid-cols-2 gap-x-5">
          <div>
            <FormField
              type="text"
              label="Naam product"
              placeholder=""
              name="name"
              form={form}
              isRequired={true}
            />
          </div>
          <div>
            <FormField
              type="text"
              label="Categorie"
              placeholder=""
              name="category"
              form={form}
              isRequired={true}
            />
          </div>
          <div>
            <FormField
              type="text"
              label="Serienummer"
              placeholder=""
              name="serial"
              form={form}
              //   isRequired={true}
            />
          </div>

          <Form.Item label="Gebruiker" name="user">
            {users ? (
              <SelectUser
                users={users}
                onSelect={(user) => form.setFieldsValue({ user: user })}
                defaultValue={form.getFieldsValue.user}
              />
            ) : (
              <LoadingSpinner />
            )}
          </Form.Item>
        </div>
        <div className="grid grid-cols-3 gap-x-5">
          <div>
            <FormField
              type="text"
              label="Factuurnummer"
              placeholder=""
              name="invoice"
              form={form}
              isRequired={false}
            />
          </div>
          <div>
            <Form.Item label="Factuurdatum" name="date">
              <DateInput
                onChange={(date) => form.setFieldsValue({ date: date })}
                value={form.getFieldsValue.date}
                allowHistoric={true}
                placeholder={''}
              />
            </Form.Item>
          </div>
        </div>
        <div className="col-span-2 my-2">
          <FormButton form={true} text={'Aanmaken'} />
        </div>
      </Form>
      {loading ? (
        <LoadingSpinner />
      ) : remoteManaged.length > 0 ? (
        <div>
          <div className="mt-5">
            <Typography tag={'h1'} type={'title'}>
              Remote managed
            </Typography>
            <SearchTable
              handleChange={handleChange}
              placeholder="Hardware zoeken..."
              value={search}
            />
            <Table header={tableHeaders}>
              {filteredRemoteManaged?.map((hardware: any, index) => (
                <tr key={index}>
                  <TableItem>
                    {/* {<TruncateString text={service.displayName} limit={30} />} */}
                    {hardware.systemName}
                  </TableItem>
                  <TableItem>
                    {hardware.displayName}
                    {/* <DateFormatted date={hardware?.lastContact * 1000} />
                    &nbsp;
                    <Time time={hardware?.lastContact * 1000} /> */}
                  </TableItem>
                  <TableItem>
                    <Checkmark check={hardware.offline ? 0 : 1} />
                  </TableItem>
                  <TableItem>
                    <Button
                      className="bg-blue-700 text-white"
                      onClick={() => onNinjaAdd(hardware.id)}
                      loading={confirmLoading}
                    >
                      Toevoegen
                    </Button>
                  </TableItem>
                </tr>
              ))}
            </Table>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AddHardware;
